{
  "manager": {
    "userRoles": {
      "assignRole": "Assign Role"
    }
  }
}
